import React from 'react';
import styled from 'styled-components';
import { Link, H3, typographyHelper } from '../../../../@nitty';
import { Container } from '../../../styles';

const View = ({ pages, currentSection }) => {
    const hasMorePages = pages > 1;

    if(!hasMorePages) return null;

    const renderPages = () => {
        const pageLinks = [];
        for (let i = 0; i < pages; i++) {
            pageLinks.push(
                <Column key={i}>
                    <Link variant="secondary" href={`/sitemap/${currentSection}/${i}`}>{i + 1}</Link>
                </Column>
            )
        }
        return pageLinks
    }

    return (
        <BarLine>
            <SytledContainer>
                <Header>More {currentSection}</Header>
                <Wrapper>
                    {renderPages()}
                </Wrapper>
            </SytledContainer>
        </BarLine>
    );
};

export default View;

const SytledContainer = styled(Container)`
    flex-direction: column;
`

const BarLine = styled.div`
    border-top: 1px solid rgb(233, 233, 233);
`

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex: 1;
`

const Column = styled.div`
    width: 2rem;
    height: 2rem;
`

const Header = styled(H3)`
    ${typographyHelper("subtitle01")}
    margin: 0 0 1rem;
`